import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Amplify, Auth } from "aws-amplify";
import { USER_AUTH_CONFIG } from "../aws-config";
import { useRecoilState } from "recoil";
import { platformState, activeScopeState } from "../global-state";
import { useAppInterface } from "../app/app-interface-provider";
import { Typography } from "@mhome/ui";
import CircularProgress from "@mui/material/CircularProgress";

const UserLogout = () => {
  const history = useHistory();
  const [platform] = useRecoilState(platformState);
  const [activeScope, setActiveScope] = useRecoilState(activeScopeState);
  const appInterface = useAppInterface();

  useEffect(() => {
    handleLogout();
  }, []);

  const handleLogout = async () => {
    try {
      localStorage.removeItem("filterParams-taskflow");
      localStorage.removeItem("filterParams-recurring");

      // Clear active scope
      setActiveScope(null);

      if (platform.source === "app" || platform.source === "desktop") {
        await appInterface.logout();
        setTimeout(() => {
          history.replace("/user-login");
        }, 100);
      } else {
        Amplify.configure(USER_AUTH_CONFIG);
        await Auth.signOut();
        setTimeout(() => {
          history.replace("/user-login");
        }, 100);
      }
    } catch (error) {
      console.error("Logout error:", error);
      history.replace("/user-login");
    }
  };

  return (
    <div
      className="flex flex-col items-center justify-center"
      style={{
        height: "100vh",
        gap: "16px",
      }}
    >
      <CircularProgress size={40} />
      <Typography variant="h6" color="text.secondary">
        Logging out...
      </Typography>
    </div>
  );
};

export default UserLogout;
